<div class="preview-container ks-p-5" *ngIf="state$ | async as state">
  <div
    class="info-card ks-p-5 ks-border-bottom-regular-solid ks-border-light-neutral"
    *ngIf="state.contact"
  >
    <div>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/contact-details.svg"
      ></span>
      <span class="ks-font-weight-medium">Contact Details</span>
    </div>
    <div class="contact-info ks-pl-10 ks-ml-2 ks-mt-3">
      <div>
        <div class="ks-body-md ks-text-dark ks-mb-3">
          <span class="text-muted">Name: </span>{{ state.contact.firstName }}
          {{ state.contact.lastName }}
        </div>
        <div class="ks-body-md ks-text-dark">
          <span class="text-muted">Financial Contact: </span>{{ state.contact.firstName }}
          {{ state.contact.lastName }}
        </div>
      </div>
    </div>
  </div>

  <div
    class="info-card ks-p-5 ks-border-bottom-regular-solid ks-border-light-neutral"
    *ngIf="state.payment_method"
  >
    <div>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/payment-method.svg"
      ></span>
      <span class="ks-font-weight-medium">Payment Method</span>
    </div>
    <div class="contact-info ks-pl-10 ks-ml-2 ks-mt-3">
      <div>
        <div class="ks-body-md ks-text-dark ks-mb-3">
          <span class="text-muted">Payment method: </span>{{ getCardLast4(state) }}
        </div>
      </div>
    </div>
  </div>

  <div class="info-card ks-p-5" *ngIf="state.amount">
    <div>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/payment-summary.svg"
      ></span>
      <span class="ks-font-weight-medium">Payment Summary</span>
    </div>
    <div class="contact-info ks-pl-10 ks-ml-2 ks-mt-3">
      <div>
        <div class="ks-body-md ks-text-dark ks-mb-3">
          <span class="text-muted">Total amount: </span>${{ state.amount }}
        </div>
        <div class="ks-body-md ks-text-dark">
          <span class="text-muted">Payment Date: </span>{{ todayLocalized }}
        </div>
      </div>
    </div>
  </div>
</div>
